import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  // This needs for future if any issues to revert.
  // loadChildren: () => import('src/app/layout/layout.module').then(m => m.LayoutModule),
  {
    path: ':tenant',
    loadChildren: () => import('./features/features.module').then(m => m.FeaturesModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
